import { apiUrl } from './config';

const AGENT_CONFIG = {
  BASEURL: apiUrl,
};

export default AGENT_CONFIG;
